export const isPromise = (arg: any) => arg instanceof Promise;
